// frontend/src/services/driveService.js
import axios from 'axios'

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api/v1'

export const connectDrive = () => {
  // --- START OF CHANGE: Point to the new dedicated reconnection endpoint ---
  // This endpoint will always force the Google consent screen.
  const googleReconnectUrl = `${API_BASE_URL}/auth/reconnect/google`
  window.location.href = googleReconnectUrl
  // --- END OF CHANGE ---
}

export const disconnectDrive = async (token) => {
  const response = await axios.post(
    `${API_BASE_URL}/drive/disconnect`,
    {}, // No body needed
    {headers: {Authorization: `Bearer ${token}`}}
  )
  return response.data
}
